import * as React from "react"
import {
    Heading,
    Flex,
    Stack,
    Text,
} from '@chakra-ui/react';

export default function LandingPageHistory({historyText}) {

    return (
        <Stack direction={{ base: 'column', lg: 'row' }} alignItems='center' spacing='100px'>
            <Flex flexGrow={1}>
                <iframe title={historyText.mapTitle} src={historyText.mapSrc} width="360" height="400" style={{border: 0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </Flex>
            <Flex flexGrow={1} gap='10'>
                <Stack>
                    <Heading pb={'15px'}>{historyText.textTitle}</Heading>
                    {historyText.textPara.map((item) => {
                        return (
                            <Text className="subTitle" fontSize={{ base: 'lg', lg: 'xl' }}>
                                {item}
                            </Text>
                        );
                    })}
                </Stack>
            </Flex>
        </Stack>
    );
}